/* Bundle included-products card — product.metafields.bundler.included_products (variant list) */
(function () {
  'use strict';

  var PRODUCT_ORDER = ['Korpus', 'Bügel', 'Deckel', 'Einlegeboden', 'Transportring'];

  var COLOR_ALIASES = {
    deepblack: ['deepblack', 'tiefschwarz', 'schwarz', 'black'],
    silvergrey: ['silvergrey', 'silvergrey', 'silbergrau', 'silber'],
    champagner: ['champagner', 'champagne', 'beige'],
    reinweiss: ['reinweiss', 'reinweiß', 'weiss', 'weiß', 'white'],
  };

  function norm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '');
  }

  function colorsMatch(a, b) {
    var na = norm(a);
    var nb = norm(b);
    if (!na || !nb) return false;
    if (na === nb) return true;
    for (var key in COLOR_ALIASES) {
      var aliases = COLOR_ALIASES[key];
      if (aliases.indexOf(na) !== -1 && aliases.indexOf(nb) !== -1) return true;
    }
    return false;
  }

  var FORM_VALUES = [
    'oval',
    'eckig',
    'basic',
    'edge',
    'rund',
    'quadrat',
    'round',
    'square',
    'rechteck',
    'rectangle',
  ];

  function classifyOptionRole(optionName) {
    var n = norm(optionName);
    // Include "bugel" — NFD-only norm strips ü→u without ae/oe/ue mapping
    if (/buegel|bugel|henkel|griff|handle/.test(n)) return 'handle';
    if (/korbfarbe|korpfarbe|korpusfarbe|bodycolor|bodyfarbe|korperfarbe/.test(n)) return 'body';
    if (/form|shape|grundform|lkshape|korbform/.test(n)) return 'form';
    if (/farbe|color|colour|couleur/.test(n)) {
      if (/korb|korpus|body/.test(n)) return 'body';
      // Plain "Farbe" / "Color" on bundle parent = body (Korpus) color
      if (/^(farbe|color|colour|couleur)$/.test(n)) return 'body';
      return 'unknown';
    }
    return 'unknown';
  }

  function isFormValue(value) {
    var n = norm(value);
    return FORM_VALUES.indexOf(n) !== -1;
  }

  function isBuegelProduct(productName) {
    return /bügel|buegel|henkel|griff|handle/i.test(productName);
  }

  function isFormColorProduct(productName) {
    return /korpus|deckel|einlegeboden|transportring|boden|ring|deck/i.test(productName);
  }

  function variantOptionValues(variant) {
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  function readProductOptionNames() {
    if (readProductOptionNames._cache) return readProductOptionNames._cache;

    var names = [];
    var productInfo = document.querySelector('product-info');

    if (productInfo) {
      var regex = /"options"\s*:\s*(\[[^\]]+\])/g;
      var match;

      while ((match = regex.exec(productInfo.innerHTML)) !== null) {
        try {
          var parsed = JSON.parse(match[1]);
          if (
            parsed.some(function (optionName) {
              var n = norm(optionName);
              return (
                /form|farbe|color|buegel|korb|shape|henkel|griff|handle/.test(n) &&
                !/^(gold|silber|oval|eckig|champagner|deepblack|black|white|grey|gray)$/.test(n)
              );
            })
          ) {
            names = parsed;
          }
        } catch (e) {
          /* try next match */
        }
      }
    }

    readProductOptionNames._cache = names;
    return names;
  }

  function selectionFromVariant(variant) {
    var pairs = [];
    var seen = {};
    if (!variant) return { pairs: pairs };

    var optionNames = Array.isArray(variant.option_names) ? variant.option_names : [];

    [variant.option1, variant.option2, variant.option3].forEach(function (value, index) {
      if (!value) return;
      var name = optionNames[index] || 'Option ' + (index + 1);
      if (seen[name]) return;
      seen[name] = true;
      var role = classifyOptionRole(name);
      if (role === 'unknown' && isFormValue(value)) role = 'form';
      pairs.push({
        name: name,
        value: value,
        role: role,
      });
    });

    return { pairs: pairs };
  }

  function readParentSelection() {
    var pairs = [];
    var seen = {};

    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input').forEach(function (node) {
      var nameEl = node.querySelector('[data-selected-swatch-value]');
      var name = nameEl ? (nameEl.getAttribute('data-selected-swatch-value') || '').trim() : '';

      if (!name) {
        var scOption = (node.getAttribute('data-sc-option') || '').trim();
        if (scOption === 'buegelfarbe') name = 'Bügelfarbe';
        else if (scOption === 'korbfarbe') name = 'Korbfarbe';
        else if (scOption === 'form') name = 'Form';
      }

      // Prefer checked input — updates immediately on click (label span can lag)
      var value = '';
      var checked = node.querySelector('input:checked');
      if (checked) {
        value = (checked.value || '').trim();
      } else {
        var select = node.querySelector('select');
        if (select) value = (select.value || '').trim();
        else if (nameEl) value = nameEl.textContent.trim();
      }

      if (!name || !value || seen[name]) return;

      seen[name] = true;
      pairs.push({
        name: name,
        value: value,
        role: classifyOptionRole(name),
      });
    });

    if (!pairs.length) {
      var variant = readParentVariant();
      var optionNames = readProductOptionNames();

      if (variant && optionNames.length) {
        [variant.option1, variant.option2, variant.option3].forEach(function (value, index) {
          if (!value || !optionNames[index]) return;
          var name = optionNames[index];
          if (seen[name]) return;
          seen[name] = true;
          pairs.push({
            name: name,
            value: value,
            role: classifyOptionRole(name),
          });
        });
      }
    }

    if (!pairs.length) {
      var fallbackVariant = readParentVariant();
      if (fallbackVariant) {
        [fallbackVariant.option1, fallbackVariant.option2, fallbackVariant.option3]
          .filter(Boolean)
          .forEach(function (value, index) {
            pairs.push({
              name: 'Option ' + (index + 1),
              value: value,
              role: isFormValue(value) ? 'form' : 'unknown',
            });
          });
      }
    }

    return { pairs: pairs };
  }

  function relevantCriteria(pairs, productName) {
    var isBuegel = isBuegelProduct(productName);
    var isFormColor = isFormColorProduct(productName);
    var hasBody = pairs.some(function (entry) {
      return entry.role === 'body' && entry.value;
    });

    return pairs.filter(function (entry) {
      if (!entry.value) return false;

      if (entry.role === 'handle') return isBuegel;
      if (entry.role === 'form') return isFormColor;
      if (entry.role === 'body') return isBuegel || isFormColor;

      if (entry.role === 'unknown') {
        if (isFormValue(entry.value)) return isFormColor;
        // Body already covers Korpusfarbe — skip stray unknown colors so a
        // misclassified Bügelfarbe cannot compete via Deep Black / Silver aliases.
        if (hasBody && isFormColor) return false;
        if (isBuegel) return true;
        if (isFormColor) return true;
      }

      return !isBuegel && !isFormColor;
    });
  }

  /**
   * Map child variant option values to roles so handle/body/form
   * never cross-match (e.g. Tiefschwarz handle ≠ Deep Black body).
   */
  function classifyVariantOptions(variant, productName) {
    var values = variantOptionValues(variant);
    var isBuegel = isBuegelProduct(productName);
    var classified = [];
    var colorCount = 0;

    values.forEach(function (value) {
      if (isFormValue(value)) {
        classified.push({ role: 'form', value: value });
        return;
      }

      if (isBuegel) {
        // Bügel: first color = handle, second = body
        classified.push({ role: colorCount === 0 ? 'handle' : 'body', value: value });
        colorCount++;
        return;
      }

      classified.push({ role: 'body', value: value });
    });

    return classified;
  }

  function rolesCompatible(criterionRole, optionRole) {
    if (!criterionRole || criterionRole === 'unknown') return true;
    if (!optionRole || optionRole === 'unknown') return true;
    return criterionRole === optionRole;
  }

  function scoreVariant(variant, criteria, productName) {
    if (!criteria.length) return -1;

    var classified = classifyVariantOptions(variant, productName);
    var matched = 0;
    // Prefer body-color + exact string hits so handle aliases
    // (Tiefschwarz↔Deep Black) cannot tie against Korpusfarbe.
    var quality = 0;

    criteria.forEach(function (entry) {
      var bestOpt = null;
      classified.forEach(function (opt) {
        if (!rolesCompatible(entry.role, opt.role)) return;
        if (!colorsMatch(opt.value, entry.value)) return;
        if (!bestOpt || norm(opt.value) === norm(entry.value)) bestOpt = opt;
      });
      if (!bestOpt) return;

      matched++;
      if (entry.role === 'body') quality += 10;
      if (norm(bestOpt.value) === norm(entry.value)) quality += 5;
    });

    return matched * 1000 - (criteria.length - matched) * 100 + quality;
  }

  function matchVariantForProduct(variants, selection, productName) {
    var criteria = relevantCriteria(selection.pairs, productName);

    if (!criteria.length && selection.pairs.length) {
      criteria = selection.pairs.filter(function (entry) {
        return entry.value;
      });
    }

    if (!criteria.length) return variants[0] || null;

    var best = null;
    var bestScore = -Infinity;

    variants.forEach(function (variant) {
      var score = scoreVariant(variant, criteria, productName);
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });

    return best;
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      return u.origin + u.pathname;
    } catch (e) {
      return String(url).split('?')[0];
    }
  }

  function swapThumbSrc(img, src, alt) {
    if (normalizeImageUrl(img.currentSrc || img.src) === normalizeImageUrl(src)) {
      img.alt = alt;
      return;
    }

    if (img.__scFadeTimer) clearTimeout(img.__scFadeTimer);

    img.classList.add('sc-bundle-included__thumb--fading');
    img.__scFadeTimer = setTimeout(function () {
      img.__scFadeTimer = null;
      img.alt = alt;

      var reveal = function () {
        requestAnimationFrame(function () {
          img.classList.remove('sc-bundle-included__thumb--fading');
        });
      };

      if (img.getAttribute('src') === src && img.complete) {
        reveal();
        return;
      }

      img.onload = function () {
        img.onload = null;
        reveal();
      };
      img.onerror = function () {
        img.onerror = null;
        reveal();
      };
      img.src = src;
      if (img.complete) reveal();
    }, 280);
  }

  function syncThumbs(container, items) {
    if (!container) return;

    var withImages = items.filter(function (item) {
      return item.image;
    });
    var existing = Array.prototype.slice.call(container.querySelectorAll('.sc-bundle-included__thumb'));

    while (existing.length > withImages.length) {
      var removed = existing.pop();
      if (removed) removed.remove();
    }

    withImages.forEach(function (item, index) {
      var img = existing[index];
      if (!img) {
        img = document.createElement('img');
        img.className = 'sc-bundle-included__thumb sc-bundle-included__thumb--fading';
        img.width = 56;
        img.height = 56;
        img.alt = item.name;
        img.loading = 'lazy';
        container.appendChild(img);
        img.onload = function () {
          img.onload = null;
          requestAnimationFrame(function () {
            img.classList.remove('sc-bundle-included__thumb--fading');
          });
        };
        img.src = item.image;
        if (img.complete) {
          requestAnimationFrame(function () {
            img.classList.remove('sc-bundle-included__thumb--fading');
          });
        }
        return;
      }

      swapThumbSrc(img, item.image, item.name);
    });
  }

  function moneyFromCents(cents) {
    return money(cents / 100);
  }

  function money(amount) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return Number(amount).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return Number(amount).toFixed(2) + ' ' + currency;
    }
  }

  function imageSrc(variant) {
    var src =
      variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : variant.featured_media &&
            variant.featured_media.preview_image &&
            variant.featured_media.preview_image.src
          ? variant.featured_media.preview_image.src
          : '';
    if (src && src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  function productLabel(variant) {
    var name = variant.name || variant.title || '';
    if (name.indexOf(' - ') !== -1) return name.split(' - ')[0].trim();
    return name.trim();
  }

  function groupVariantsByProduct(variants) {
    var groups = {};
    var order = [];

    variants.forEach(function (variant) {
      var label = productLabel(variant);
      if (!label) return;
      if (!groups[label]) {
        groups[label] = [];
        order.push(label);
      }
      groups[label].push(variant);
    });

    order.sort(function (a, b) {
      var ai = PRODUCT_ORDER.indexOf(a);
      var bi = PRODUCT_ORDER.indexOf(b);
      if (ai === -1) ai = 999;
      if (bi === -1) bi = 999;
      return ai - bi;
    });

    return { groups: groups, order: order };
  }

  function readParentVariant() {
    var selectedEl = document.querySelector('product-info [data-selected-variant]');
    if (selectedEl && selectedEl.textContent) {
      try {
        return JSON.parse(selectedEl.textContent);
      } catch (e) {
        /* fall through */
      }
    }
    return null;
  }

  function resolveVariantListItems(variants, selection) {
    var grouped = groupVariantsByProduct(variants);
    var items = [];

    grouped.order.forEach(function (productName) {
      var match = matchVariantForProduct(grouped.groups[productName], selection, productName);
      if (!match) return;

      var regularCents = match.compare_at_price || match.price || 0;
      var bundleCents = match.price || 0;

      items.push({
        name: productName,
        image: imageSrc(match),
        regularCents: regularCents,
        bundleCents: bundleCents,
      });
    });

    return items;
  }

  function stripLeadingCommaFromElement(el) {
    if (!el) return;

    el.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(/^[\s,]+/, function (match) {
          return match.indexOf(',') !== -1 ? ' ' : match;
        });
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        stripLeadingCommaFromElement(node);
      }
    });
  }

  class ScBundleIncluded extends HTMLElement {
    connectedCallback() {
      if (this.__scInit) return;
      this.__scInit = true;

      var configEl = this.querySelector('[data-sc-bundle-included-config]');
      if (!configEl) return;

      try {
        this.rawConfig = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      this.card = this.querySelector('[data-sc-bundle-included-card]');
      this.namesEl = this.querySelector('[data-sc-bundle-included-names]');
      var namesContainer = this.querySelector('.sc-bundle-included__names');
      if (namesContainer) {
        var metafields = namesContainer.querySelectorAll('.metafield-rich_text_field');
        this.suffixEl =
          namesContainer.querySelector('.sc-bundle-included__suffix') ||
          (metafields.length > 1
            ? metafields[metafields.length - 1]
            : this.namesEl && metafields.length
              ? metafields[0]
              : null);
      } else {
        this.suffixEl = null;
      }
      stripLeadingCommaFromElement(this.suffixEl);
      this.thumbsEl = this.querySelector('[data-sc-bundle-included-thumbs]');
      this.compareEl = this.querySelector('[data-sc-bundle-included-compare]');
      this.totalEl = this.querySelector('[data-sc-bundle-included-total]');
      this.__scLastRenderKey = '';

      this.onChange = this.scheduleRender.bind(this);
      this.onVariantSelectChange = function (event) {
        if (!event.target.closest('variant-selects')) return;
        this.scheduleRender();
      }.bind(this);

      this.productInfo = document.querySelector('product-info');
      document.addEventListener('variant:changed', this.onChange);
      if (this.productInfo) {
        this.productInfo.addEventListener('change', this.onVariantSelectChange);
      }

      if (window.FoxTheme && FoxTheme.pubsub) {
        this.variantUnsub = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.onChange
        );
      }

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onChange);
      if (this.productInfo) {
        this.productInfo.removeEventListener('change', this.onVariantSelectChange);
      }
      if (this.variantUnsub) this.variantUnsub();
      if (this.__scRenderTimer) clearTimeout(this.__scRenderTimer);
    }

    scheduleRender() {
      var self = this;
      if (this.__scRenderTimer) clearTimeout(this.__scRenderTimer);
      // Coalesce change + variant:changed + pubsub into one paint
      this.__scRenderTimer = setTimeout(function () {
        self.__scRenderTimer = null;
        self.render();
      }, 0);
    }

    getItems() {
      if (Array.isArray(this.rawConfig)) {
        return resolveVariantListItems(this.rawConfig, readParentSelection());
      }

      if (this.rawConfig && (this.rawConfig.groups || this.rawConfig.fixed)) {
        return this.resolveRuntimeItems(this.rawConfig, readParentSelection());
      }

      return [];
    }

    resolveRuntimeItems(config, selection) {
      var items = [];
      var groups = config.groups || [];
      var fixed = config.fixed || [];
      var state = {};

      groups.forEach(function (group) {
        if (group.defaultVariantId) state[group.id] = group.defaultVariantId;
      });

      function findOption(groupId, variantId) {
        var group = groups.find(function (g) {
          return g.id === groupId;
        });
        if (!group) return null;
        return (group.options || []).find(function (o) {
          return String(o.variantId).slice(-12) === String(variantId).slice(-12);
        });
      }

      function optionsForGroup(group) {
        var options = group.options || [];
        if (!group.matchGroupId) return options;
        var matchGroup = groups.find(function (g) {
          return g.id === group.matchGroupId;
        });
        if (!matchGroup) return options;
        var selectedId = state[matchGroup.id];
        if (!selectedId) return options;
        var selectedOpt = findOption(matchGroup.id, selectedId);
        return options.filter(function (option) {
          var compatible = option.compatibleVariants || [];
          if (compatible.length) {
            return compatible.some(function (id) {
              return String(id).slice(-12) === String(selectedId).slice(-12);
            });
          }
          return true;
        }).filter(function (option) {
          if (!selectedOpt) return true;
          if (option.compat && selectedOpt.compat) return option.compat === selectedOpt.compat;
          return true;
        });
      }

      groups.forEach(function (group) {
        var avail = optionsForGroup(group);
        if (!avail.length) return;
        var current = state[group.id];
        var valid = current && avail.some(function (o) {
          return String(o.variantId).slice(-12) === String(current).slice(-12);
        });
        if (!valid) state[group.id] = avail[0].variantId;
      });

      fixed.forEach(function (component) {
        var qty = component.quantity || 1;
        for (var i = 0; i < qty; i++) {
          items.push({
            name: component.productTitle || component.title,
            image: component.image,
            regularCents: Math.round(parseFloat(component.regularPrice || 0) * 100),
            bundleCents: Math.round(parseFloat(component.bundlePrice || 0) * 100),
          });
        }
      });

      groups.forEach(function (group) {
        var option = findOption(group.id, state[group.id]);
        if (!option) return;
        var qty = group.quantity || 1;
        for (var j = 0; j < qty; j++) {
          items.push({
            name: group.title || option.productTitle || option.title,
            image: option.image,
            regularCents: Math.round(parseFloat(option.regularPrice || 0) * 100),
            bundleCents: Math.round(parseFloat(option.bundlePrice || 0) * 100),
          });
        }
      });

      return items;
    }

    calculatePrices(items) {
      var parent = readParentVariant();
      if (parent && parent.price) {
        return {
          regularCents: parent.compare_at_price || parent.price,
          bundleCents: parent.price,
        };
      }

      return items.reduce(
        function (acc, item) {
          acc.regularCents += item.regularCents;
          acc.bundleCents += item.bundleCents;
          return acc;
        },
        { regularCents: 0, bundleCents: 0 }
      );
    }

    render() {
      var items = this.getItems();

      if (!items.length) {
        this.__scLastRenderKey = '';
        if (this.card) this.card.classList.add('sc-bundle-included__card--empty');
        return;
      }

      var prices = this.calculatePrices(items);
      var renderKey = items
        .map(function (item) {
          return item.name + '|' + item.image;
        })
        .join(';') +
        '|' +
        prices.bundleCents +
        '|' +
        prices.regularCents;

      if (renderKey === this.__scLastRenderKey) return;
      this.__scLastRenderKey = renderKey;

      if (this.namesEl) {
        this.namesEl.textContent = items
          .map(function (item) {
            return item.name;
          })
          .join(', ');
      }

      if (this.thumbsEl) {
        syncThumbs(this.thumbsEl, items);
      }

      if (this.totalEl) this.totalEl.textContent = moneyFromCents(prices.bundleCents);

      if (this.compareEl) {
        if (prices.regularCents > prices.bundleCents) {
          this.compareEl.textContent = moneyFromCents(prices.regularCents);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }

      if (this.card) this.card.classList.remove('sc-bundle-included__card--empty');
    }
  }

  if (!customElements.get('sc-bundle-included')) {
    customElements.define('sc-bundle-included', ScBundleIncluded);
  }

  function isKorpusProduct(productName) {
    return /korpus/i.test(productName || '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  class ScBundleGalleryAccessories extends HTMLElement {
    connectedCallback() {
      if (this.__scInit) return;
      this.__scInit = true;

      var configEl = this.querySelector('[data-sc-bundle-gallery-config]');
      if (!configEl) return;

      try {
        this.rawConfig = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      this.parentVariant = null;
      var parentEl = this.querySelector('[data-sc-parent-variant]');
      if (parentEl && parentEl.textContent) {
        try {
          this.parentVariant = JSON.parse(parentEl.textContent);
        } catch (e) {
          this.parentVariant = null;
        }
      }

      this.imagesEl = this.querySelector('[data-sc-bundle-gallery-images]');
      this.__scLastRenderKey = '';

      this.onChange = this.scheduleRender.bind(this);
      this.onVariantSelectChange = function (event) {
        if (!event.target.closest('variant-selects')) return;
        this.scheduleRender();
      }.bind(this);

      if (!this.parentVariant) {
        this.productInfo = document.querySelector('product-info');
        document.addEventListener('variant:changed', this.onChange);
        if (this.productInfo) {
          this.productInfo.addEventListener('change', this.onVariantSelectChange);
        }

        if (window.FoxTheme && FoxTheme.pubsub) {
          this.variantUnsub = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            this.onChange
          );
        }
      }

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onChange);
      if (this.productInfo) {
        this.productInfo.removeEventListener('change', this.onVariantSelectChange);
      }
      if (this.variantUnsub) this.variantUnsub();
      if (this.__scRenderTimer) clearTimeout(this.__scRenderTimer);
    }

    getItems() {
      var items = [];
      var selection = this.parentVariant
        ? selectionFromVariant(this.parentVariant)
        : readParentSelection();

      if (Array.isArray(this.rawConfig)) {
        items = resolveVariantListItems(this.rawConfig, selection);
      }

      return items.filter(function (item) {
        return !isKorpusProduct(item.name);
      });
    }

    scheduleRender() {
      var self = this;
      if (this.__scRenderTimer) clearTimeout(this.__scRenderTimer);
      this.__scRenderTimer = setTimeout(function () {
        self.__scRenderTimer = null;
        self.render();
      }, 0);
    }

    render() {
      var items = this.getItems().filter(function (item) {
        return item.image;
      });

      if (!items.length) {
        this.__scLastRenderKey = '';
        this.hidden = true;
        return;
      }

      var renderKey = items
        .map(function (item) {
          return item.name + '|' + item.image;
        })
        .join(';');

      if (renderKey === this.__scLastRenderKey) {
        this.hidden = false;
        return;
      }
      this.__scLastRenderKey = renderKey;

      this.hidden = false;

      if (!this.imagesEl) return;

      this.imagesEl.innerHTML = items
        .map(function (item, index) {
          var name = escapeHtml(item.name);
          return (
            '<div class="sc-bundle-gallery-accessories__item" style="--sc-item-index: ' +
            index +
            '">' +
            '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            name +
            '" loading="lazy" width="72" height="72">' +
            '<span class="sc-bundle-gallery-accessories__tooltip">' +
            name +
            '</span>' +
            '</div>'
          );
        })
        .join('');
    }
  }

  if (!customElements.get('sc-bundle-gallery-accessories')) {
    customElements.define('sc-bundle-gallery-accessories', ScBundleGalleryAccessories);
  }
})();
